var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGarnituraSticlaWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b54c0b45-b50d-49aa-b4de-92e96754dc4a",
    "data-name": "garnitura_sticla",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b17d0e29-f1e1-4098-a098-94fc20ce293a,.e2f6430b-37e6-434a-8452-452aaf5c7f8f,.f67c702d-6eed-478d-9cdf-b5cbd23acaa5{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.e2f6430b-37e6-434a-8452-452aaf5c7f8f{stroke-width:10px;}.b17d0e29-f1e1-4098-a098-94fc20ce293a{stroke-width:5px;}.f67c702d-6eed-478d-9cdf-b5cbd23acaa5{stroke-width:8px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "garnitura_sticla_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a0044013-a4c0-4efa-8fef-f4a7834a5909",
    "data-name": "fereastra"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "e2f6430b-37e6-434a-8452-452aaf5c7f8f",
    points: "28.75 188 195 188 195 5 5 5 5 139.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b17d0e29-f1e1-4098-a098-94fc20ce293a",
    x1: 160.35,
    y1: 14.69,
    x2: 184.38,
    y2: 37.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "b17d0e29-f1e1-4098-a098-94fc20ce293a",
    x1: 131.29,
    y1: 15.76,
    x2: 183.26,
    y2: 65.82
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f67c702d-6eed-478d-9cdf-b5cbd23acaa5",
    points: "20.77 129.79 20.77 172.85 54.29 172.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "b17d0e29-f1e1-4098-a098-94fc20ce293a",
    points: "31.94 129.26 31.94 162.09 53.73 162.09"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarnituraSticlaWhite);
export default __webpack_public_path__ + "static/media/garnitura_sticla_white.91bfe3b273562beb0c8a6c84405de90b.svg";
export { ForwardRef as ReactComponent };